import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CircularIndeterminate from '../loadingSpinner.tsx';
import Box from '@mui/material/Box';

type Props = {
  headers?: any,
  data?: any,
  isLoading?: boolean,
  handleViewItem?: (item: any) => void,
}

export default function DataTable({ headers, data, isLoading, handleViewItem }: Props) {
  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            {headers?.map((el: any, index: number) => {
              return <TableCell key={`header-${el.value}-${index}`}>{el.label}</TableCell>
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell colSpan={headers?.length || 7} style={{ textAlign: 'center' }}>
                <Box display="flex" justifyContent="center">
                  <CircularIndeterminate />
                </Box>
              </TableCell>
            </TableRow>
          ) : data?.length > 0 ? (
            data?.map((row: any, idx: number) => {
              return (
                <TableRow
                  key={row.id || row._id || `row-${idx}`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  onClick={() => handleViewItem && handleViewItem(row)}
                  style={{ cursor: handleViewItem ? 'pointer' : '' }}
                >
                  {headers?.map((el: any, cellIndex: number) => {
                    return (
                      <TableCell key={`cell-${row.id || row._id || idx}-${el.value}-${cellIndex}`}>
                        {row[el.value]}
                      </TableCell>
                    )
                  })}
                </TableRow>
              )
            })
          ) : (
            <TableRow>
              <TableCell colSpan={headers?.length || 7} style={{ textAlign: 'center' }}>
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}